const schoolContact = {
  name: "Vzdělávací centrum Maryam z.s.",
  address: {
    street: "Úzká 799",
    city: "Slavkov u Brna",
    postalCode: "684 01",
    country: "Česká republika"
  },
  contact: {
    phone: "724 997 887",
    email: "skola.maryam@gmail.com",
    ico: "08849650"
  },
  mapLocation: {
    address: "Úzká 799, 684 01 Slavkov u Brna",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2607.0437490437844!2d16.87584471570675!3d49.15439077931787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4712ecb5db97a3e9%3A0xb888868efe727ce!2zw5p6a8OhIDc5OSwgNjg0IDAxIFNsYXZrb3YgdSBCcm5h!5e0!3m2!1scs!2scz!4v1626877357118!5m2!1scs!2scz"
  }
};

export default schoolContact; 
